
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  description: 'API reference for endpoints and webhooks associated with the Plaid Identity Verification product.',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Identity Verification' subtitle='API reference for Identity Verification endpoints and webhooks' compact mdxType="Header" />
    <p>{`For how-to guidance, see the `}<a parentName="p" {...{
        "href": "/docs/identity-verification/"
      }}>{`Identity Verification documentation`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoints`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/identity_verification/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create a new identity verification`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/identity_verification/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve a previously created identity verification`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/identity_verification/list`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter and list identity verifications`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/identity_verification/retry`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Allow a user to retry an identity verification`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`See also`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/dashboard_user/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve information about a dashboard user`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/dashboard_user/list`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List dashboard users`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#status_updated"
            }}><inlineCode parentName="a">{`STATUS_UPDATED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The status of an identity verification has been updated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#step_updated"
            }}><inlineCode parentName="a">{`STEP_UPDATED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A step in the identity verification process has been completed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#retried"
            }}><inlineCode parentName="a">{`RETRIED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An identity verification has been retried`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h3>
    <h4 {...{
      "id": "identity_verificationcreate"
    }}>{`/identity_verification/create`}</h4>
    <Schema method='POST' route='/identity_verification/create' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/identity_verification/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: IdentityVerificationCreateRequest = {
  client_user_id: 'user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d',
  is_shareable: true,
  template_id: 'idvtmp_52xR9LKo77r1Np',
  gave_consent: true,
  user: {
    email_address: 'acharleston@email.com',
    phone_number: '+12345678909',
    date_of_birth: '1975-01-18',
    name: {
      given_name: 'Anna',
      family_name: 'Charleston',
    },
    address: {
      street: '100 Market Street',
      street2: 'Apt 1A',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94103',
      country: 'US',
    },
    id_number: {
      value: '123456789',
      type: 'us_ssn',
    },
  },
};
try {
  const response = await client.identityVerificationCreate(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/identity_verification/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_user_id": "user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d",
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "is_shareable": true,
  "template_id": "idvtmp_52xR9LKo77r1Np",
  "gave_consent": true,
  "user": {
    "email_address": "acharleston@email.com",
    "phone_number": "+12345678909",
    "date_of_birth": "1975-01-18",
    "name": {
      "given_name": "Anna",
      "family_name": "Charleston"
    },
    "address": {
      "street": "100 Market Street",
      "street2": "Apt 1A",
      "city": "San Francisco",
      "region": "CA",
      "postal_code": "94103",
      "country": "US"
    },
    "id_number": {
      "value": "123456789",
      "type": "us_ssn"
    }
  }
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`require 'date'

request = Plaid::IdentityVerificationCreateRequest.new(
  {
    client_user_id: 'user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d',
    is_shareable: true,
    template_id: 'idvtmp_52xR9LKo77r1Np',
    gave_consent: true,
    user: Plaid::IdentityVerificationCreateRequestUser.new(
      {
        email_address: 'acharleston@email.com',
        phone_number: '+12345678909',
        date_of_birth: Date.new(1975, 1, 18),
        name: Plaid::IdentityVerificationRequestUserName.new(
          {
            given_name: 'Anna',
            family_name: 'Charleston'
          }
        ),
        address: Plaid::UserAddress.new(
          {
            street: '100 Market Street',
            street2: 'Apt 1A',
            city: 'San Francisco',
            region: 'CA',
            postal_code: '94103',
            country: 'US'
          }
        ),
        id_number: Plaid::UserIDNumber.new(
          {
            value: '123456789',
            type: Plaid::IDNumberType::US_SSN
          }
        )
      }
    )
  }
)
response = client.identity_verification_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`import java.time.LocalDate;

LocalDate dob = LocalDate.parse("1975-01-18");

IdentityVerificationRequestUserName name = new IdentityVerificationRequestUserName()
  .givenName("Anna")
  .familyName("Charleston");

UserAddress address = new UserAddress()
  .street("100 Market Street")
  .street2("Apt 1A")
  .city("San Francisco")
  .region("CA")
  .postalCode("94103")
  .country("US");

IDNumberType type = IDNumberType.US_SSN;

UserIDNumber idNumber = new UserIDNumber()
  .value("123456789")
  .type(type);

IdentityVerificationCreateRequestUser user = new IdentityVerificationCreateRequestUser()
  .emailAddress("acharleston@email.com")
  .phoneNumber("+12345678909")
  .dateOfBirth(dob)
  .name(name)
  .address(address)
  .idNumber(idNumber);

IdentityVerificationCreateRequest request = new IdentityVerificationCreateRequest()
  .clientUserId("user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d")
  .isShareable(true)
  .templateId("idvtmp_52xR9LKo77r1Np")
  .gaveConsent(true)
  .user(user);

Response<IdentityVerificationCreateResponse> response = client()
  .identityVerificationCreate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`from datetime import date

request = IdentityVerificationCreateRequest(
    client_user_id='user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d',
    is_shareable=True,
    template_id='idvtmp_52xR9LKo77r1Np',
    gave_consent=True,
    user=IdentityVerificationCreateRequestUser(
        email_address='acharleston@email.com',
        phone_number='+12345678909',
        date_of_birth=date(1975, 1, 18),
        name=IdentityVerificationRequestUserName(
            given_name='Anna',
            family_name='Charleston'
        ),
        address=UserAddress(
            street='100 Market Street',
            street2='Apt 1A',
            city='San Francisco',
            region='CA',
            postal_code='94103',
            country='US'
        ),
        id_number=UserIDNumber(
          value='123456789',
          type=IDNumberType('us_ssn')
        )
    )
)
response = client.identity_verification_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`user := plaid.NewIdentityVerificationCreateRequestUser()
user.SetEmailAddress("acharleston@email.com")
user.SetPhoneNumber("+12345678909")
user.SetDateOfBirth("1975-01-18")
user.SetName(
  *plaid.NewIdentityVerificationRequestUserName(
    "Anna",
    "Charleston",
  ),
)
address := plaid.NewUserAddress("US")
address.SetStreet("100 Market Street")
address.SetCity("San Francisco")
address.SetRegion("CA")
address.SetPostalCode("94103")
user.SetAddress(*address)
user.SetIdNumber(
  *plaid.NewUserIDNumber(
    "123456789",
    plaid.IDNUMBERTYPE_US_SSN,
  ),
)

request := plaid.NewIdentityVerificationCreateRequest(
  true,
  "idvtmp_52xR9LKo77r1Np",
  true,
)
request.SetClientUserId("user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d")
request.SetUser(*user)

response, _, err := client.PlaidApi.
  IdentityVerificationCreate(ctx).
  IdentityVerificationCreateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    identity "github.com/plaid/plaid-go/v49/identity"
)

user := &plaid.IdentityVerificationCreateRequestUser{}
user.EmailAddress = plaid.String("acharleston@email.com")
user.PhoneNumber = plaid.String("+12345678909")
user.DateOfBirth = plaid.Time(time.Date(1975, 1, 18, 0, 0, 0, 0, time.UTC))
user.Name = &plaid.IdentityVerificationRequestUserName{
    GivenName:  "Anna",
    FamilyName: "Charleston",
}
address := &plaid.UserAddress{Country: "US"}
address.Street = plaid.String("100 Market Street")
address.City = plaid.String("San Francisco")
address.Region = plaid.String("CA")
address.PostalCode = plaid.String("94103")
user.Address = address
user.IDNumber = &plaid.UserIDNumber{
    Value: "123456789",
    Type:  plaid.IDNumberTypeUsSsn,
}

request := &identity.IdentityVerificationCreateRequest{
    IsShareable: true,
    TemplateID:  "idvtmp_52xR9LKo77r1Np",
    GaveConsent: true,
}
request.ClientUserID = plaid.String("user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d")
request.User = user

response, err := client.Identity.Verification.Create(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/identity_verification/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "identity_verificationget"
    }}>{`/identity_verification/get`}</h4>
    <Schema method='POST' route='/identity_verification/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/identity_verification/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: IdentityVerificationGetRequest = {
  identity_verification_id: 'idv_52xR9LKo77r1Np',
};
try {
  const response = await plaidClient.identityVerificationGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/identity_verification/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "identity_verification_id": "idv_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::IdentityVerificationGetRequest.new({ identity_verification_id: 'idv_52xR9LKo77r1Np' })
response = client.identity_verification_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`IdentityVerificationGetRequest request = new IdentityVerificationGetRequest()
  .identityVerificationId("idv_52xR9LKo77r1Np");

Response<IdentityVerificationGetResponse> response = client()
  .identityVerificationGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = IdentityVerificationGetRequest(identity_verification_id='idv_52xR9LKo77r1Np')
response = client.identity_verification_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewIdentityVerificationGetRequest(
  "idv_52xR9LKo77r1Np",
)

response, _, err := client.PlaidApi.
  IdentityVerificationGet(ctx).
  IdentityVerificationGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    identity "github.com/plaid/plaid-go/v49/identity"
)

request := &identity.IdentityVerificationGetRequest{IdentityVerificationID: "idv_52xR9LKo77r1Np"}

response, err := client.Identity.Verification.Get(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/identity_verification/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "identity_verificationlist"
    }}>{`/identity_verification/list`}</h4>
    <Schema method='POST' route='/identity_verification/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/identity_verification/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/identity_verification/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "template_id": "idvtmp_52xR9LKo77r1Np",
  "client_user_id": "user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: IdentityVerificationListRequest = {
  template_id: 'idvtmp_52xR9LKo77r1Np',
  client_user_id: 'user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d',
};
try {
  const response = await plaidClient.identityVerificationList(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = IdentityVerificationListRequest(
  template_id='idvtmp_52xR9LKo77r1Np',
  client_user_id='user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d'
)
response = client.identity_verification_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::IdentityVerificationListRequest.new(
  {
    template_id: 'idvtmp_52xR9LKo77r1Np',
    client_user_id: 'user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d'
  }
)
response = client.identity_verification_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`IdentityVerificationListRequest request = new IdentityVerificationListRequest()
  .templateId("idvtmp_52xR9LKo77r1Np")
  .clientUserId("user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d");

Response<IdentityVerificationListResponse> response = client()
  .identityVerificationList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewIdentityVerificationListRequest(
  "idvtmp_52xR9LKo77r1Np",
)
request.SetClientUserId("user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d")

response, _, err := client.PlaidApi.
  IdentityVerificationList(ctx).
  IdentityVerificationListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    identity "github.com/plaid/plaid-go/v49/identity"
)

request := &identity.IdentityVerificationListRequest{TemplateID: "idvtmp_52xR9LKo77r1Np"}
request.ClientUserID = plaid.String("user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d")

response, err := client.Identity.Verification.List(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/identity_verification/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "identity_verificationretry"
    }}>{`/identity_verification/retry`}</h4>
    <Schema method='POST' route='/identity_verification/retry' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/identity_verification/retry' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/identity_verification/retry \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "client_user_id": "user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d",
  "template_id": "idvtmp_52xR9LKo77r1Np",
  "strategy": "reset",
  "user": {
    "email_address": "acharleston@email.com",
    "phone_number": "+12345678909",
    "date_of_birth": "1975-01-18",
    "name": {
      "given_name": "Anna",
      "family_name": "Charleston"
    },
    "address": {
      "street": "100 Market Street",
      "street2": "Apt 1A",
      "city": "San Francisco",
      "region": "CA",
      "postal_code": "94103",
      "country": "US"
    },
    "id_number": {
      "value": "123456789",
      "type": "us_ssn"
    }
  }
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: IdentityVerificationRetryRequest = {
  client_user_id: 'user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d',
  template_id: 'idvtmp_52xR9LKo77r1Np',
  strategy: 'reset',
  user: {
    email_address: 'acharleston@email.com',
    phone_number: '+12345678909',
    date_of_birth: '1975-01-18',
    name: {
      given_name: 'Anna',
      family_name: 'Charleston',
    },
    address: {
      street: '100 Market Street',
      street2: 'Apt 1A',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94103',
      country: 'US',
    },
    id_number: {
      value: '123456789',
      type: 'us_ssn',
    },
  },
};
try {
  const response = await plaidClient.identityVerificationRetry(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = IdentityVerificationRetryRequest(
  client_user_id='user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d',
  template_id='idvtmp_52xR9LKo77r1Np',
  strategy=Strategy('reset'),
  user=IdentityVerificationRequestUser(
    email_address='acharleston@email.com',
    phone_number='+12345678909',
    date_of_birth=date(1975, 1, 18),
    name=IdentityVerificationRequestUserName(
        given_name='Anna',
        family_name='Charleston'
    ),
    address=UserAddress(
        street='100 Market Street',
        street2='Apt 1A',
        city='San Francisco',
        region='CA',
        postal_code='94103',
        country='US'
    ),
    id_number=UserIDNumber(
      value='123456789',
      type=IDNumberType('us_ssn')
    )
  )
)
response = client.identity_verification_retry(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::IdentityVerificationRetryRequest.new(
  {
    client_user_id: 'user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d',
    template_id: 'idvtmp_52xR9LKo77r1Np',
    strategy: Plaid::Strategy::RESET,
    user: Plaid::IdentityVerificationRequestUser.new(
      {
        email_address: 'acharleston@email.com',
        phone_number: '+12345678909',
        date_of_birth: Date.new(1975, 1, 18),
        name: Plaid::IdentityVerificationRequestUserName.new(
          {
            given_name: 'Anna',
            family_name: 'Charleston'
          }
        ),
        address: Plaid::UserAddress.new(
          {
            street: '100 Market Street',
            street2: 'Apt 1A',
            city: 'San Francisco',
            region: 'CA',
            postal_code: '94103',
            country: 'US'
          }
        ),
        id_number: Plaid::UserIDNumber.new(
          {
            value: '123456789',
            type: Plaid::IDNumberType::US_SSN
          }
        )
      }
    ),
  }
)
response = client.identity_verification_retry(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`Strategy strategy = Strategy.RESET;
LocalDate dob = LocalDate.parse("1975-01-18");

IdentityVerificationRequestUserName name = new IdentityVerificationRequestUserName()
  .givenName("Anna")
  .familyName("Charleston");

UserAddress address = new UserAddress()
  .street("100 Market Street")
  .street2("Apt 1A")
  .city("San Francisco")
  .region("CA")
  .postalCode("94103")
  .country("US");

IDNumberType type = IDNumberType.US_SSN;

UserIDNumber idNumber = new UserIDNumber()
  .value("123456789")
  .type(type);

IdentityVerificationRequestUser user = new IdentityVerificationRequestUser()
  .emailAddress("acharleston@email.com")
  .phoneNumber("+12345678909")
  .dateOfBirth(dob)
  .name(name)
  .address(address)
  .idNumber(idNumber);

IdentityVerificationRetryRequest request = new IdentityVerificationRetryRequest()
  .clientUserId("user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d")
  .templateId("idvtmp_52xR9LKo77r1Np")
  .strategy(strategy)
  .user(user);

Response<IdentityVerificationRetryResponse> response = client()
  .identityVerificationRetry(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`user := plaid.NewIdentityVerificationRequestUser()
user.SetEmailAddress("acharleston@email.com")
user.SetPhoneNumber("+12345678909")
user.SetDateOfBirth("1975-01-18")
user.SetName(
  *plaid.NewIdentityVerificationRequestUserName(
    "Anna",
    "Charleston",
  ),
)
address := plaid.NewUserAddress("US")
address.SetStreet("100 Market Street")
address.SetCity("San Francisco")
address.SetRegion("CA")
address.SetPostalCode("94103")
user.SetAddress(*address)
user.SetIdNumber(
  *plaid.NewUserIDNumber(
    "123456789",
    plaid.IDNUMBERTYPE_US_SSN,
  ),
)

request := plaid.NewIdentityVerificationRetryRequest(
  "user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d",
  "idvtmp_52xR9LKo77r1Np",
  plaid.STRATEGY_RESET,
)
request.SetUser(*user)

response, _, err := client.PlaidApi.
  IdentityVerificationRetry(ctx).
  IdentityVerificationRetryRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    identity "github.com/plaid/plaid-go/v49/identity"
)

user := &plaid.IdentityVerificationRequestUser{}
user.EmailAddress = plaid.String("acharleston@email.com")
user.PhoneNumber = plaid.String("+12345678909")
user.DateOfBirth = plaid.Time(time.Date(1975, 1, 18, 0, 0, 0, 0, time.UTC))
user.Name = &plaid.IdentityVerificationRequestUserName{
    GivenName:  "Anna",
    FamilyName: "Charleston",
}
address := &plaid.UserAddress{Country: "US"}
address.Street = plaid.String("100 Market Street")
address.City = plaid.String("San Francisco")
address.Region = plaid.String("CA")
address.PostalCode = plaid.String("94103")
user.Address = address
user.IDNumber = &plaid.UserIDNumber{
    Value: "123456789",
    Type:  plaid.IDNumberTypeUsSsn,
}

request := &identity.IdentityVerificationRetryRequest{
    ClientUserID: "user-sandbox-b0e2c4ee-a763-4df5-bfe9-46a46bce993d",
    TemplateID:   "idvtmp_52xR9LKo77r1Np",
    Strategy:     plaid.StrategyReset,
}
request.User = user

response, err := client.Identity.Verification.Retry(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/identity_verification/retry' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "webhooks"
    }}>{`Webhooks`}</h3>
    <h4 {...{
      "id": "status_updated"
    }}><inlineCode parentName="h4">{`STATUS_UPDATED`}</inlineCode></h4>
    <Schema model='IdentityVerificationStatusUpdatedWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "step_updated"
    }}><inlineCode parentName="h4">{`STEP_UPDATED`}</inlineCode></h4>
    <Schema model='IdentityVerificationStepUpdatedWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "retried"
    }}><inlineCode parentName="h4">{`RETRIED`}</inlineCode></h4>
    <Schema model='IdentityVerificationRetriedWebhook' type='model' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "endpoints",
        level: 3,
        title: "Endpoints",
      },
{
        id: "identity_verificationcreate",
        level: 4,
        title: "/identity_verification/create",
      },
{
        id: "identity_verificationget",
        level: 4,
        title: "/identity_verification/get",
      },
{
        id: "identity_verificationlist",
        level: 4,
        title: "/identity_verification/list",
      },
{
        id: "identity_verificationretry",
        level: 4,
        title: "/identity_verification/retry",
      },
{
        id: "webhooks",
        level: 3,
        title: "Webhooks",
      },
{
        id: "status_updated",
        level: 4,
        title: "STATUS_UPDATED",
      },
{
        id: "step_updated",
        level: 4,
        title: "STEP_UPDATED",
      },
{
        id: "retried",
        level: 4,
        title: "RETRIED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
